import "@/types/MiniProfiler";
import { FeatureManagementType } from "@api/apiClient";
import axios from "@api/axiosInstance";
import { useEffect, useState } from "react";
import useAppStore from "./useAppStore";

const ERROR_MESSAGE = "MiniProfiler could not be loaded: ";

export interface MiniProfilerProps {
  enabled: boolean;
}

const useMiniProfiler = (enabled: MiniProfilerProps) => {
  console.log('useMiniProfiler: ', enabled);
  const appStore = useAppStore();
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    if (appStore.hasFeature(FeatureManagementType.MiniProfiler)) {
      if (!isLoaded) {
        console.log("Loading MiniProfiler");
        setIsLoaded(true);

        // @ts-ignore hush
        window.MiniProfiler.init({
          id: "mini-profiler",
          version: "4.3.8+1120572909",
          path: "/api/mini-profiler-resources/",
          currentI: "5436c02f-8552-4dc5-b05e-779a6901e554",
          ids: "",
          position: "Right",
          scheme: "Light",
          decimalPlaces: "2",
          authorized: "true",
          trivial: "true",
          children: "true",
          controls: "true",
          startHidden: "true",
          maxTraces: "30",
          toggleShortcut: "Alt+P",
          trivialMilliseconds: "2.0",
          ignoredDuplicateExecuteTypes: "Open,OpenAsync,Close,CloseAsync",
        });
      }

    }
  }, [enabled, appStore.applicationSettings]);

  useEffect(() => {
    axios.interceptors.request.use((config: any) => {
      if (appStore.isProfilingEnabled) {
        config.headers["X-MiniProfiler"] = "true";
      } else {
        delete config.headers["X-MiniProfiler"];
      }
      return config;
    });
  }, [appStore.isProfilingEnabled]);
};

export default useMiniProfiler;